import { track } from "~/modules/analytics/track";
import { BillingUserEvents } from "~/modules/analytics/events/billing";

// // // //

/**
 * trackClickCheckoutButton
 * Tracks the event when a user clicks the checkout submit button in the CheckoutForm
 */
export function trackClickCheckoutButton(props?: {
    organizationId?: string;
    startTrial?: boolean;
    academic?: boolean;
    monthly50?: boolean;
}) {
    track(BillingUserEvents.ClickCheckoutButton, props);
}

/**
 * trackPaywallDrawerCloseIconClick
 * Tracks the event when a user dismisses the PaywallDrawer via the close (X) icon
 */
export function trackPaywallDrawerCloseIconClick() {
    track(BillingUserEvents.PaywallDrawerCloseIconClick);
}

/**
 * trackPaywallDrawerMaybeLaterClick
 * Tracks the event when a user dismisses the PaywallDrawer via the "Maybe later" button
 */
export function trackPaywallDrawerMaybeLaterClick() {
    track(BillingUserEvents.PaywallDrawerMaybeLaterClick);
}

/**
 * trackPaywallDrawerSignInClick
 * Tracks the event when a user clicks the "Sign in" link in the PaywallDrawer
 */
export function trackPaywallDrawerSignInClick() {
    track(BillingUserEvents.PaywallDrawerSignInLinkClick);
}
